// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-mobile__wrapper[data-v-f20ee078]{background:#000;color:#fff;padding:0 24px}.header-mobile__wrapper .header-mobile__gap-filler[data-v-f20ee078]{position:absolute;top:-1px;background:#000;height:1px;width:100%;z-index:1;left:0}", ""]);
// Exports
module.exports = exports;
